import { Drawer, notification, Radio, Space } from 'antd';
import { Fragment, useRef, useState } from 'react';
import { GMedication } from '../../store/db';
import { track } from '../../tracking';
import { GUIItem } from './ListGenieItems';

const answerObj: { [k: string]: string } = {
    'incorrect-generic': 'Incorrect Generic',
    'incorrect-medicines': 'Incorrect Medicines',
    'duplicate-suggestion': 'Duplicate Suggestion',
    other: 'Other',
};

export const IssuesWithSuggestion: React.FC<{ currentMedicine: GUIItem }> = ({
    currentMedicine,
}) => {
    const [isDrawerVisible, setIsDrawerVisible] = useState(false);
    const [answer, setAnswer] = useState('');
    const inputRef = useRef<HTMLTextAreaElement>(null);

    const toggleIsDrawerVisible = () => {
        setIsDrawerVisible(!isDrawerVisible);
        setAnswer('');
        if (inputRef.current) inputRef.current.value = '';
    };

    const submitFeedbackHandler = () => {
        const { name, suggestions, meta } = currentMedicine as GUIItem & GMedication;
        const otherReason = inputRef.current?.value.trim();
        if (!answer) {
            notification.error({
                message: 'Please select reason',
                duration: 5,
            });
            return;
        }
        if (answer === 'other' && !otherReason) {
            notification.error({
                message: 'Please add reason',
                duration: 5,
            });
            return;
        }
        track('ISSUES_WITH_SUGGESTIONS', {
            name,
            usageCount: String(meta?.fCount),
            reason: answer === 'other' ? otherReason : answerObj[answer],
            suggestionIds: suggestions?.map((i) => i.id).join(', '),
            suggestionNames: suggestions?.map((i) => i.name).join(', '),
        });
        notification.success({
            message: 'Thanks for your feedback.',
            duration: 5,
        });
        toggleIsDrawerVisible();
    };

    return (
        <Fragment>
            <div className="flex items-center">
                <button
                    className="px-16 py-6 text-darwin-primary-500 font-700 bg-white rounded-4 hover-child-element whitespace-nowrap"
                    onClick={() => setIsDrawerVisible(true)}
                >
                    Issues with suggestion?
                </button>
            </div>

            {isDrawerVisible && (
                <Drawer
                    placement="right"
                    closable
                    onClose={toggleIsDrawerVisible}
                    mask={true}
                    visible={true}
                    getContainer={false}
                    className="bg-transparent"
                    maskStyle={{
                        opacity: '0',
                        animation: 'none',
                    }}
                    bodyStyle={{
                        padding: '0px',
                        backgroundColor: 'transparent',
                    }}
                    headerStyle={{ display: 'none' }}
                    width={360}
                    destroyOnClose
                    closeIcon={null}
                >
                    <div className="flex flex-col h-full">
                        <div className="flex items-center justify-between px-16 py-12">
                            <p className="font-700 text-darwin-neutral-900">
                                Please tell us your issue
                            </p>

                            <svg
                                className="w-14 h-14"
                                viewBox="0 0 12 12"
                                xmlns="http://www.w3.org/2000/svg"
                                onClick={toggleIsDrawerVisible}
                            >
                                <path
                                    d="M10.75 9.71875C11.0312 10.0312 11.0312 10.5 10.75 10.7812C10.4375 11.0938 9.96875 11.0938 9.6875 10.7812L6 7.0625L2.28125 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 1.96875 0.90625 1.5 1.21875 1.21875C1.5 0.90625 1.96875 0.90625 2.25 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.75 1.25C11.0625 1.53125 11.0625 2 10.75 2.3125L7.03125 6L10.75 9.71875Z"
                                    fill="#4C5980"
                                />
                            </svg>
                        </div>

                        <div className="px-16 pt-12 flex-1 overflow-scroll border-t border-b border-neutral-7">
                            <Radio.Group onChange={(e) => setAnswer(e.target.value)} value={answer}>
                                <Space direction="vertical">
                                    {Object.entries(answerObj).map((i, index) => (
                                        <Radio
                                            value={i[0]}
                                            key={index}
                                            className={`${i[0] === answer ? 'font-700' : ''}`}
                                        >
                                            {i[1]}
                                        </Radio>
                                    ))}
                                </Space>
                            </Radio.Group>
                            {answer === 'other' && (
                                <textarea
                                    className="w-320 h-72 mt-12 resize-none border border-neutral-7 rounded-8 p-12"
                                    ref={inputRef}
                                    placeholder="Please add your reason here..."
                                ></textarea>
                            )}
                        </div>

                        <div className="flex px-16 py-10 flex items-center justify-between">
                            <button
                                className="font-700 text-darwin-primary-500"
                                onClick={toggleIsDrawerVisible}
                            >
                                Cancel
                            </button>

                            <button
                                className="px-12 py-8 text-white bg-darwin-primary-500 rounded-3 font-700"
                                onClick={submitFeedbackHandler}
                            >
                                Submit feedback
                            </button>
                        </div>
                    </div>
                </Drawer>
            )}
        </Fragment>
    );
};
